import { getSelectedQuickFilters } from 'store/quickFilters/selectors'

export const getSelectedFilters = (state) =>
  state.orderListFilters.selectedFilters
export const getAppliedFilters = (state) => ({
  ...state.orderListFilters.appliedFilters,
  status: getSelectedQuickFilters(state),
})
export const getSearchFilter = (state) => state.orderListFilters.searchFilter
